import styles from "./TicketCard.module.css";

/**
 * A single floating "ticket" — the site's signature visual motif.
 * icon: small inline SVG element
 * tilt: base resting rotation, e.g. "-3deg"
 * float: "slow" | "med" | "none"
 * notchBg: background color to punch the stub-notches through
 *          (match whatever section the ticket sits on)
 */
function TicketCard({
  icon,
  label,
  title,
  description,
  price,
  unit,
  tilt = "-2deg",
  float = "slow",
  notchBg,
  style,
  className = "",
}) {
  const floatClass =
    float === "slow" ? "floatSlow" : float === "med" ? "floatMed" : "";

  return (
    <div
      className={`${styles.ticket} ${floatClass} ${className}`}
      style={{
        "--tilt": tilt,
        ...(notchBg ? { "--notch-bg": notchBg } : {}),
        ...style,
      }}
    >
      <div className={styles.iconRow}>
        {icon && <span className={styles.icon}>{icon}</span>}
        {label && <span className={styles.label}>{label}</span>}
      </div>

      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.desc}>{description}</p>}

      {price && (
        <>
          <hr className={styles.tearLine} />
          <div className={styles.priceRow}>
            <span className={styles.price}>{price}</span>
            {unit && <span className={styles.unit}>{unit}</span>}
          </div>
        </>
      )}
    </div>
  );
}

export default TicketCard;
